<template>
    <div>
        <div class="main-view">
            <div class="dialog-view">
                <div class="view-top">
                    <div class="left">配置详情</div>
                    <div class="right">
                        <i @click="closeDetail" class="el-icon-close" style="color: #868383;;cursor: pointer;"></i>
                    </div>
                </div>
                <div class="view-main">
                    <div class="main-top">门店情况统计</div>
                    <div class="main-list" >
                        <div class="list-item" v-for="item,index in storeslist" :key="index">
                            <div class="item-left">
                                <div class="left-div">{{ item.displayName }}</div>
                            </div>
                            <!-- <div class="item-right">{{ getValue(item.checked) }}</div> -->
                            <div class="item-right">
                                <el-checkbox v-model="item.checked" onclick="return false"></el-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="view-line"></div>
                <div class="view-main" v-if="singleStorelist.length > 0">
                    <div class="main-top">单店执行情况</div>
                    <div class="main-list">
                        <div class="list-item" v-for="item,index in singleStorelist" :index="index">
                            <div class="item-left">
                                <div class="left-div">{{ item.displayName }}</div>
                            </div>
                            <!-- <div class="item-right">{{ getValue(item.checked) }}</div> -->
                            <div class="item-right">
                                <el-checkbox v-model="item.checked" onclick="return false"></el-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="view-btn">
                    <div class="btn" @click="closeDetail">返回</div>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
    import gameplanApi from '../../../api/gameplan';
    export default {
      name: 'config-buChange-pop',
      props: {
        themeId:{type:String, default:'' },
      },
      components: {
      },
      data () {
        return { 
            execDataConfigList:{},
            storeslist:[],
            singleStorelist:[]
        }
      },
      computed: {
      },
      watch: {},
      created () {
        this.init()
      },
      mounted () {},
      updated () {
      },
      methods: {
        init () {
            this.getExecDataConfig()
        },
        // 查询动态业务数据字段
        async getExecDataConfig() {
            let params = {
                themeId: this.themeId
            }
            const { data } = await gameplanApi.getExecDataConfig(params);
            if (data.resultCode === "0") {
                this.execDataConfigList = data.resultData.execDataConfigList || []
                let storeslist = []
                let singleStorelist = []
                for (let item of this.execDataConfigList) {
                    if (item.fieldGroupName == "门店情况统计" ) {
                        storeslist.push(item)
                    }
                    // && item.checked == true 
                    if (item.fieldGroupName == "单店执行情况") {
                        singleStorelist.push(item)
                    }
                }
                this.storeslist = storeslist
                this.singleStorelist = singleStorelist
                // console.log(storeslist,'storeslist');
                // console.log(singleStorelist,'singleStorelist');
            }
        },
        closeDetail () {
            this.$emit('closeChangepop')
        },
        getValue (val) {
            if (val == true) {
                return '是'
            } else {
                return '否'
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.main-view {
    .dialog-view {
        background-color: #ffffff;
        border-radius: 4px;
        overflow: hidden;
        overflow-y: scroll;
        max-height: 80vh;
        .view-top {
            height: 32px;
            line-height: 32px;
            display: flex;
            margin-bottom: 15px;
            .left {
                font-size: 20px;
                // font-weight: 600;
                flex: 1;
                color: #868383;
            }
            .right {
                width: 32px;
                height: 32px;
                font-size: 20px;
                color: #868383;
            }
        }
        .view-main {
            font-size: 14px;
            color: #1D1D1D;
            .main-top {
                height: 26px;
                line-height: 26px;
                color: #868383;
                font-weight: 600;
                // padding-left: 30px;
                margin-bottom: 10px;
            }
            .main-list {
                display: flex;
                flex-wrap: wrap;
                color: #868383;
                .list-item {
                    width: 50%;
                    display: flex;
                    text-align: left;
                    padding: 7px 0px;
                    .item-left {
                        padding-left: 40px;
                        width: 80%;
                        .left-div {
                            line-height: 23px;
                        }
                    }
                    .item-right {
                        flex: 1;
                        line-height: 23px;
                        text-align: left;
                        ::v-deep .is-indeterminate .el-checkbox__inner {
                            background-color: #acacac  !important;
                            border-color: #acacac  !important;
                        }
                        ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
                        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
                            background-color: #acacac  !important;
                            border-color: #acacac  !important;
                        }

                        ::v-deep .el-checkbox__inner:hover,
                        ::v-deep .el-checkbox__input .el-checkbox__inner:focus {
                            border-color: #acacac  !important;
                        }

                        ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner,
                        ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner:hover {
                            border-color: #acacac  !important;
                        }
                    }
                }
            }
        }
        .view-line {
            height: 1px;
            background-color: #868383;
            // width: 95%;
            // margin: 20px auto;
            opacity: 0.4;
        }
        .view-btn {
            margin: 30px 0px 0px 0px;
            height: 30px;
            line-height: 30px;
            .btn {
                margin: auto;
                width: 80px;
                text-align: center;
                background-color: #FFFFFF;
                color: #cd1231;
                border-radius: 5px;
                border: 1px solid #cd1231;
                cursor: pointer;
            }
        }
    }
}
</style>
